import React, { Dispatch, SetStateAction } from 'react';

import MDEditor from '@uiw/react-md-editor';

import { JSONEditor } from '../../../components/json-editor';
import { FileState } from '../../../utils/models/common-models';


interface EvaluatorProps {
    selectedFile: string;
    fileStates: FileState;
    setFileStates: Dispatch<SetStateAction<FileState>>;
}

const Evaluator: React.FC<EvaluatorProps> = ({
    selectedFile,
    fileStates,
    setFileStates,
}) => {
    return (
        <>
            {selectedFile?.endsWith(".py") && (
                <>
                    <div id="blockmirror-editor"></div>
                    <div id='outputEditor'></div>
                </>
            )}

            {selectedFile?.endsWith(".json") && (
                <JSONEditor
                    path="input_json.json"
                    language="json"
                    schemaValue={"{}"}
                    isSchemaSampleDataOn={false}
                    value={fileStates[selectedFile]}
                    onChange={(value: string | undefined) => {
                        setFileStates(prevData => ({ ...prevData, [selectedFile]: value || "{}" }))
                    }}
                />
            )}

            {selectedFile.endsWith(".md") && (
                <div data-color-mode="light" style={{ height: '100%', width: '100%' }}>
                    <MDEditor
                        value={fileStates[selectedFile]}
                        onChange={(value) => setFileStates(prevData => ({ ...prevData, [selectedFile]: value }))}
                        height="100%"
                    />
                </div>
            )}

            {selectedFile.endsWith(".txt") && (
                <JSONEditor
                    language="txt"
                    isSchemaSampleDataOn={false}
                    value={fileStates[selectedFile]}
                    onChange={(value: string | undefined) => {
                        setFileStates(prevData => ({ ...prevData, [selectedFile]: value || "" }))
                    }}
                />
            )}

            {selectedFile === "Dockerfile" && (
                <JSONEditor
                    language="dockerfile"
                    // editorReadOnly={true}
                    isSchemaSampleDataOn={false}
                    value={fileStates[selectedFile]}
                    onChange={(value: string | undefined) => {
                        setFileStates(prevData => ({ ...prevData, [selectedFile]: value || "" }))
                    }}
                />
            )}
        </>
    )
}

export default Evaluator